import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IGroup } from '../types/IGroup';

export interface ISearchActiveDirectoryGroupNameParams {
  name: string;
}

export interface ISearchActiveDirectoryGroupNameResult extends IResult {
  groups: IGroup[];
  hasMoreItems: boolean; // true if the list of groups is incomplete (reached truncation limit).
}

export class SearchActiveDirectoryGroupNameRequest extends Request<ISearchActiveDirectoryGroupNameParams, ISearchActiveDirectoryGroupNameResult> {
  constructor(params: ISearchActiveDirectoryGroupNameParams) {
    super('searchActiveDirectoryGroupName', params);
  }
}
